module.exports = __webpack_public_path__ + "static/og-c9eeec96588239b0ef6d8f3f4d4871bc.png";